import React, { Component, Fragment } from 'react'
import { firebaseApp } from '../base'


export default class Login extends Component {

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this)
        this.login = this.login.bind(this)
        this.toogleForm = this.toogleForm.bind(this)
        this.forgotPassword = this.forgotPassword.bind(this)
        
        this.state = {
            email:'',
            password:'',
            displayForgotPassword: false,
            error:''
        }
    }

    

    handleChange(e) {
        this.setState({[e.target.name]: e.target.value})
    }

    login(e) {
        e.preventDefault()
        firebaseApp.auth().signInWithEmailAndPassword(this.state.email, this.state.password)
            .then((u) => {})
            .catch((e) => {
                const error = 'Incorrect email or password'
                this.setState({error})
            })
    }

    forgotPassword(e) {
        e.preventDefault()
        const email = this.state.email
        firebaseApp.auth().sendPasswordResetEmail(email).then(function (user) {
            alert('Please check your email...')
          }).catch((e) => {
            const error = 'Unknown email'
            this.setState({error})
          })
    }

    toogleForm(){
        if(this.state.displayForgotPassword){
            const displayForgotPassword = false
            this.setState({displayForgotPassword})
        }else{
            const displayForgotPassword = true
            this.setState({displayForgotPassword})
        }
    }



   
    render() {
        const displayForgotPassword = this.state.displayForgotPassword
        const error = this.state.error
        return (
            <Fragment>
                <header id="header">
                    <div className="container">
                        <div id="main-logo">
                            <a href='/'>
                                Centre Médical
                            <br/>
                                Bonnevoie
                            </a>
                        </div>
                    </div>
                </header>
                <header id="sub-header">
                    <div className="container">
                        <p className="schedule">
                           Modifications informations
                        </p>
                        
                    </div>
                </header>
                
                <main id="main">
                    <div id="ghost_banner"></div>
                    <div className="content">
                    
                    {displayForgotPassword ? 
                     <form className="form__signin" onSubmit={this.authenticate}>
                        <h1 className="">Please enter your mail</h1>

                        <input name='email' value={this.state.email}
                        onChange={this.handleChange} type="text" id="inputEmail"
                        className="form-control" placeholder="Email" required="" autoFocus="" />

                        {error && <div className="form__link--error">{error}</div>}
                        <button onClick={this.forgotPassword} className="button primary">Reset password</button>
                        <span className="form__link--bottom" onClick={this.toogleForm}>Return to login</span>
                        
                    </form>
                    :
                    <form className="form__signin" onSubmit={this.authenticate}>
                        <h1 className="">Please sign in</h1>

                        <input name='email' value={this.state.email}
                        onChange={this.handleChange} type="text" id="inputEmail"
                        className="form-control" placeholder="Email" required="" autoFocus="" />

                        <input name='password' value={this.state.password}
                        onChange={this.handleChange} type="password" id="inputPassword"
                        className="form-control" placeholder="Password" required="" />

                        {error && <div className="form__link--error">{error}</div>}
                        <button onClick={this.login} className="button primary" type="submit">Login</button>
                        <span className="form__link--bottom" onClick={this.toogleForm}>Forgot password ?</span>
                        
                        
                    </form>
                }
                    
                    

                               
                    </div>
                </main>
                
            </Fragment>
            
        
        )
    }
}
